import { axiosInstance } from "../api/baseQuery";

const DAY_KEY = "terakki_visit_day";
let lastPath = null;

/** İstanbul günü "YYYY-MM-DD". */
function today() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Istanbul" }).format(new Date());
}

/**
 * Tanıtım sayfası görüntülemesini anonim olarak sayar. Bugün ilk kez gelen
 * tarayıcı tekil ziyaretçi sayılır; bunun için yalnız gün tarihi yerelde
 * tutulur, çerez ya da kimlik yok. Hata sessizce yutulur.
 */
export function recordSiteVisit(path) {
  if (path === lastPath) return; // StrictMode çift çağrısı, aynı sayfa
  lastPath = path;
  let newVisitor = false;
  try {
    const day = today();
    if (localStorage.getItem(DAY_KEY) !== day) {
      localStorage.setItem(DAY_KEY, day);
      newVisitor = true;
    }
  } catch {
    // Depolama kapalıysa yalnız görüntüleme sayılır.
  }
  axiosInstance.post("/api/public/visits", { newVisitor }).catch(() => {});
}
